import {NgModule} from '@angular/core';
import {DetailComponent} from './detail/detail';
import {ActionButtonComponent} from './action-button/action-button';
import {CarlisleHeaderComponent} from './carlisle-header/carlisle-header';
import {MyApp} from "../app/app.component";
import {IonicModule} from "ionic-angular";
import {BannerComponent} from './banner/banner';

@NgModule({
    declarations: [DetailComponent, ActionButtonComponent, CarlisleHeaderComponent,
        BannerComponent],
    imports: [IonicModule],
    exports: [DetailComponent, ActionButtonComponent, CarlisleHeaderComponent,
        BannerComponent]
})
export class ComponentsModule
{
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts